import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function StatsBar() {
  const [stats, setStats] = useState({
    opportunities: 0,
    companies: 0
  });
  
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { count: oppCount } = await supabase
          .from('opportunities')
          .select('*', { count: 'exact', head: true })
          .eq('status', 'approved');
        
        const { data: companies } = await supabase
          .from('opportunities')
          .select('company')
          .eq('status', 'approved');
        
        const uniqueCompanies = new Set(companies?.map(c => c.company) || []);
        
        setStats({
          opportunities: oppCount || 0,
          companies: uniqueCompanies.size || 0
        });
      } catch (error) {
        console.error('Error fetching stats:', error);
        setStats({
          opportunities: 76,
          companies: 45
        });
      }
    };
    
    fetchStats();
  }, []);
  
  return (
    <div className="flex items-center gap-8 text-white/90">
      <div className="flex items-baseline gap-2">
        <span className="text-3xl md:text-4xl font-bold text-white">
          {stats.opportunities}+
        </span>
        <span className="text-sm uppercase tracking-wide text-white/60">
          Opportunités
        </span>
      </div>
      <div className="w-px h-8 bg-white/20" />
      <div className="flex items-baseline gap-2">
        <span className="text-3xl md:text-4xl font-bold text-white">
          {stats.companies}+
        </span>
        <span className="text-sm uppercase tracking-wide text-white/60">
          Entreprises
        </span>
      </div>
    </div>
  );
}
